import { SVGProps } from 'react';

const SvgArrowNarrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 16 10" {...props}>
    <path
      stroke="#292929"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1 5h14M1 5l4 4M1 5l4-4"
    />
  </svg>
);

export default SvgArrowNarrowLeft;
